<!-- 法规详情页 -->
<template>
    <div class="v-lawdetails">
        <c-header></c-header>
        <div class="content">
            <Breadcrumb separator=">">
                <BreadcrumbItem to="/home">首页</BreadcrumbItem>
                <BreadcrumbItem to="/lawlist">法规列表</BreadcrumbItem>
                <BreadcrumbItem>{{ DetailsData.lawTitle }}</BreadcrumbItem>
            </Breadcrumb>

            <div class="details-panel">
                <div class="law-title">{{ DetailsData.lawTitle }}</div>
                <div class="law-info">
                    <p class="law-info-p">
                        <span class="info-key">发布部门：</span>
                        <span class="info-value">{{ DetailsData.publishDeptNames }}</span>
                    </p>
                    <p class="law-info-p">
                        <span class="info-key">发文字号：</span>
                        <span class="info-value info-key-gray">{{ DetailsData.publishDocCode }}</span>
                    </p>
                    <p class="law-info-p">
                        <span class="info-p-container">
                            <span class="info-key">发布日期：</span>
                            <span class="info-value info-key-gray">{{ DetailsData.publishDate }}</span>
                        </span>
                        <span class="info-p-container">
                            <span class="info-key">实施日期：</span>
                            <span class="info-value info-key-gray">{{ DetailsData.releaseDate }}</span>
                        </span>
                    </p>
                    <p class="law-info-p">
                        <span class="info-p-container">
                            <span class="info-key">时效性：</span>
                            <span class="info-value"
                                v-html="renderDetailsDict(DetailsData.sxId, 'sxId', 'sxName')"></span>
                        </span>
                        <span class="info-p-container">
                            <span class="info-key">效力级别：</span>
                            <span class="info-value"
                                v-html="renderDetailsDict(DetailsData.xljbId, 'effectLevelId', 'effectLevelName')"></span>
                        </span>
                    </p>
                    <p class="law-info-p">
                        <span class="info-key">法规类别：</span>
                        <span class="info-value"
                            v-html="renderDetailsDict(DetailsData.lawTypeId, 'lawTypeId', 'lawTypeName')"></span>
                    </p>
                    <!-- <p class="law-info-p">
            <span class="info-key">修改依据：</span>
            <span class="info-value">？？？</span>
          </p> -->
                </div>
                <!-- 本法变迁模块 -->
                <div class="law-change">
                    <div class="panel-title">本法变迁</div>
                    <div class="panel-content">
                        <ul class="timeline-list">
                            <li class="timeline-item">
                                <span class="timeline-time"></span>
                                <span class="timeline-icon">
                                    <i class="icon-timeline"></i>
                                </span>
                                <span class="timeline-line"></span>
                                <span class="timeline-describe"></span>
                                <span class="timeline-label">
                                    <!-- <span>比对</span> -->
                                </span>
                            </li>
                            <li class="timeline-item" v-for="(item, index) in ChangesData" :key="index">
                                <span class="timeline-time">{{ item.publish_date }}</span>
                                <span class="timeline-icon">
                                    <i class="icon-item"></i>
                                </span>
                                <span class="timeline-line"></span>
                                <span class="timeline-describe">{{ item.law_title }}</span>
                                <span class="timeline-label">
                                    <!-- <span>比对</span> -->
                                </span>
                                <!-- 比对标签没用上 -->
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="law-cause">
                    <div class="panel-title">本法事由</div>
                    <Row class="panel-content">
                        <!-- 事由导航树 -->
                        <Col span="6">
                        <div class="cause-nav" id="cause-nav">
                            <Tree :data="TreeData" @on-toggle-expand="toggleTree($event)"
                                @on-select-change="selectTreeItem"></Tree>
                        </div>
                        </Col>
                        <!-- 事由 -->
                        <Col span="18" id="cause-content">
                        <div class="cause-details">
                            <div class="cause-details-item" v-for="(item, index) in LawCauseData">
                                <!-- 事由内容 -->
                                <p class="cause-details-law"
                                    :class="{'cause-details-law-active': ActiveItem == item.itemId}"
                                    :id="'cause-details-law-' + item.itemId">
                                    <!-- {{ item.itemId }} -->
                                    <span class="law-ztk">{{ item.displayItemName }}</span>
                                    <span class="law-text">{{ item.itemContent }}</span>
                                </p>
                                <!-- 事由详情 -->
                                <div class="cause-details-children" v-if="item.children && item.children.length > 0"
                                    v-for="citem in item.children">
                                    <p class="cause-details-line1"
                                        :class="{'cause-details-children-active': ActiveItem == item.itemId}">
                                        <a href="javascript:void(0);"
                                            class="item-fix-width item-font-weight">{{ '【' + citem.excuteTypeName + '】' }}</a>
                                        <span class="cause-details-span" :class="{'cause-details-span-active': ActiveItem == item.itemId}">
                                            <span class="item-font-weight item-margin">事由名称：</span>
                                            <span>{{ citem.causeName }}</span>
                                        </span>
                                        <a href="javascript:void(0);" style="margin: 0 12px;"
                                            @click="showCauseDetails(citem)">查看</a>
                                    </p>
                                    <p class="cause-details-line2"
                                        :class="{'cause-details-children-active': ActiveItem == item.itemId}">
                                        <span class="item-fix-width"></span>
                                        <span class="item-font-weight item-margin">事由编码：</span>
                                        <span style="margin-right: 8px;">{{ citem.causeCode }}</span>
                                        <span class="item-font-weight item-margin">依据类型：</span>
                                        <span style="margin-right: 8px; width: 120px;">{{ citem.itemTypeName }}</span>
                                        <span class="item-font-weight item-margin">处罚种类：</span>
                                        <span style="margin-right: 8px; width: 200px;">{{ citem.punishName }}</span>
                                    </p>
                                    <!-- 展开详情面板 -->
                                    <div class="cause-details-panel hide-panel" :ref="'details-panel-' + citem.causeId">
                                        <p class="panel-p-item">
                                            <span class="details-panel-title">执法事项：</span>
                                            <span>{{ citem.excuteTypeName }}</span>
                                        </p>
                                        <p class="panel-p-item">
                                            <span class="details-panel-title">事由名称：</span>
                                            <span>{{ citem.causeName }}</span>
                                        </p>
                                        <p class="panel-p-item">
                                            <span class="details-panel-title">程序类型：</span>
                                            <span v-html="renderBizId(citem.bizId)"></span>
                                        </p>
                                        <!-- 裁量数据表 -->
                                        <p v-if="citem.punishs && citem.punishs.length > 0">
                                            <span class="details-panel-title">处罚裁量：</span>
                                        <table class="cl-table" cellspacing="0" cellpadding="0">
                                            <tr>
                                                <th style="width: 20%;">裁量情形</th>
                                                <th style="width: 15%;">处罚类型</th>
                                                <th style="width: 15%;">职能级别</th>
                                                <th style="width: 20%;">职能部门</th>
                                                <th style="width: 30%;">裁量幅度</th>
                                            </tr>
                                            <tr v-for="ccitem in citem.punishs">
                                                <td style="width: 20%;">{{ ccitem.situationDesc }}</td>
                                                <td style="width: 15%;">{{ ccitem.punishType.excuteTypeName }}</td>
                                                <td style="width: 15%;"
                                                    v-html="renderArr(ccitem.funcLevels, 'unitFuncLevelName')"></td>
                                                <td style="width: 20%;"
                                                    v-html="renderArr(ccitem.funcUnits, 'unitFuncTypeName')"></td>
                                                <td style="width: 30%;" v-html="renderClData(ccitem)"></td>
                                            </tr>
                                        </table>
                                        </p>
                                        <!-- 违则数据表 -->
                                        <p v-if="citem.items && citem.items.length > 0">
                                            <span class="details-panel-title">违则：</span>
                                        <table class="punish-table" cellspacing="0" cellpadding="0">
                                            <tr>
                                                <th style="width: 30%;">法规名称</th>
                                                <th style="width: 20%;">法规款项</th>
                                                <th style="width: 50%;">法规内容</th>
                                            </tr>
                                            <!-- 违则 itemTypeId = 1 -->
                                            <tr v-for="ccitem in citem.items" v-if="ccitem.itemTypeId == 1">
                                                <td style="width: 30%;">{{ ccitem.lawTitle }}</td>
                                                <td style="width: 20%;">{{ ccitem.itemName }}</td>
                                                <td style="width: 50%;">{{ ccitem.itemContent }}</td>
                                            </tr>
                                        </table>
                                        </p>
                                        <!-- 准用依据数据表 -->
                                        <p v-if="citem.items && citem.items.length > 0">
                                            <span class="details-panel-title">准用依据：</span>
                                        <table class="punish-table" cellspacing="0" cellpadding="0">
                                            <tr>
                                                <th style="width: 30%;">法规名称</th>
                                                <th style="width: 20%;">法规款项</th>
                                                <th style="width: 50%;">法规内容</th>
                                            </tr>
                                            <!-- 准用依据 itemTypeId = 10 -->
                                            <tr v-for="ccitem in citem.items" v-if="ccitem.itemTypeId == 10">
                                                <td style="width: 30%;">{{ ccitem.lawTitle }}</td>
                                                <td style="width: 20%;">{{ ccitem.itemName }}</td>
                                                <td style="width: 50%;">{{ ccitem.itemContent }}</td>
                                            </tr>
                                        </table>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
        <c-footer></c-footer>
    </div>
</template>

<script>
    import CHeader from '@/components/CHeader'
    import CFooter from '@/components/CFooter'
    import { reqLawDetails, reqLawChanges, reqLawDetailsTree, reqLawDetailsCause } from "@/api/index";
    export default {
        name: 'VLawDetails',
        components: {
            CHeader,
            CFooter
        },
        props: {
            // 小驼峰命名
            demoInfo: {
                type: String,
                default() {
                    return 'lawdetails-demo'
                }
            }
        },
        data() {
            return {
                oC: null,
                TreeHeight: '',
                // 选中的事由
                ActiveItem: '',
                // 选中的详情
                ActiveDetailsItem: '',
                // 法规详情数据
                DetailsData: {},
                // 本法变迁数据
                ChangesData: [],
                // 本法事由树数据
                TreeData: [],
                // 本法事由数据
                LawCauseData: [],
            }
        },
        computed: {

        },
        watch: {

        },
        created() {

        },
        mounted() {
            this.renderNavCss();
            this.getLawDetailsData();
            this.getLawChangesData();
            this.getLawTreeData();
            this.getLawCauseData();
        },
        destroyed() {

        },
        methods: {
            // 功能 渲染裁量数据
            renderClData(data) {
                let result = '';
                // 行政拘留
                if (data.punishType.excuteTypeId == 16) {
                    data.clDetails.forEach(item => {
                        result += `拘留下限：${item.lowerLimit}天； 拘留上限：${item.topLimit}天；<br>`;
                    });
                }
                // 其他处罚
                else if (data.punishType.excuteTypeId == 17) {
                    data.clDetails.forEach(item => {
                        result += `具体处罚内容：${item.punishDetail}<br>`;
                    });
                }
                else {
                    data.clDetails.forEach(item => {
                        // 渲染单位
                        let unit = '';
                        if (item.lowerUnit == 1) {
                            unit = '元';
                        }
                        if (item.lowerUnit == 2) {
                            unit = '倍';
                        }
                        if (item.lowerUnit == 3) {
                            unit = '元/单位';
                        }
                        if (item.lowerUnit == 4) {
                            unit = '%';
                        }

                        // 区间罚款
                        if (item.punishType == 1) {
                            result += `类型：${item.objTypeName}； 罚款类型：区间罚款; <br>罚款下限：${item.lowerLimit}${item.lowerUnitName}； 罚款上限：${item.topLimit}${item.topUnitName}；<br>`;
                        }
                        // 定额罚款
                        if (item.punishType == 2) {
                            result += `类型：${item.objTypeName}； 罚款类型：定额罚款; <br>定额罚款：${item.lowerLimit}${unit}；<br>`;
                        }
                        // 倍比罚款
                        if (item.punishType == 3) {
                            result += `类型：${item.objTypeName}； 罚款类型：倍比罚款; <br>罚款下限：${item.lowerLimit}${unit}； 罚款上限：${item.topLimit}${unit}；<br>罚款基准：${item.standard};<br>`;
                        }
                    });
                }
                return result;
            },

            // 功能 渲染职能级别、职能部门数据
            renderArr(data, key) {
                let result = [];
                data.forEach(item => {
                    result.push(item[key]);
                });
                return result.join(',');
            },

            // 功能 渲染程序类型内容
            renderBizId(data) {
                // bizId   2一般  1,2一般和简易
                let result = '';
                if (data) {
                    if (data.indexOf(1) != -1) {
                        result = '一般和简易';
                    } else {
                        result = '一般程序';
                    }
                }
                return result;
            },

            showCauseDetails(data) {
                let ele = this.$refs[`details-panel-${data.causeId}`][0];
                if (ele.className == 'cause-details-panel hide-panel') {
                    ele.className = 'cause-details-panel';
                } else {
                    ele.className = 'cause-details-panel hide-panel';
                }
            },

            toggleTree(data) {
                if (data.expand) {
                    this.renderNavCss();
                }
            },

            selectTreeItem(data) {
                console.log(data)
                if (data[0].itemId) {
                    this.ActiveItem = data[0].itemId;
                    document.getElementById('cause-details-law-' + this.ActiveItem).scrollIntoView();
                }
            },

            renderNavCss() {
                setTimeout(() => {
                    if (document.getElementsByClassName('ivu-tree-arrow-open')[0]) {
                        this.oC = document.getElementsByClassName('ivu-tree-arrow-open')[0].parentNode.children;
                        this.oC[1].style.border = 'none';
                        if (this.oC[this.oC.length - 1].children.length > 0) {
                            this.oC[this.oC.length - 1].children[0].children[1].style.border = 'none';
                        }
                    }
                }, 500);
            },

            // 请求 获取法规详情数据
            getLawDetailsData() {
                // reqLawDetails({id: 29513}).then(res => {
                reqLawDetails({ id: this.$route.query.id }).then(res => {
                    if (res.ok) {
                        this.DetailsData = res.data;
                    }
                });
            },

            renderDetailsDict(data, key, nameKey) {
                let result = '';
                if (key == 'sxId') {
                    this.$store.state.dict.sx.forEach(item => {
                        if (item[key] == data) {
                            result = item[nameKey];
                        }
                    })
                }
                if (key == 'effectLevelId') {
                    this.$store.state.dict.xljb.forEach(item => {
                        if (item[key] == data) {
                            result = item[nameKey];
                        }
                    })
                }
                if (key == 'lawTypeId') {
                    this.$store.state.dict.lawType.forEach(item => {
                        if (item[key] == data) {
                            result = item[nameKey];
                        }
                    })
                }
                return result;
            },

            // 请求 获取本法变迁数据
            getLawChangesData() {
                reqLawChanges({ lawId: this.$route.query.id }).then(res => {
                    // reqLawChanges({lawId: 29513}).then(res => {
                    if (res.ok) {
                        this.ChangesData = res.data;
                    }
                });
            },

            // 请求 获取本法变迁数据
            getLawTreeData() {
                reqLawDetailsTree({ id: this.$route.query.id, excuteTypeId: 0 }).then(res => {
                    // reqLawDetailsTree({id: 29513, excuteTypeId: 0}).then(res => {
                    if (res.ok) {
                        this.TreeData = [{
                            title: res.data.label,
                            expand: res.data.expanded,
                            children: this.filterChildrenData(res.data.children)
                        }];
                        setTimeout(() => {
                            this.TreeHeight = document.getElementById('cause-nav').clientHeight;
                            document.getElementById('cause-content').style.minHeight = `${this.TreeHeight}px`;
                        }, 200)
                    }
                });
            },

            // 功能 递归组织children的树结构
            filterChildrenData(data) {
                let result = [];
                if (data && data.length > 0) {
                    data.forEach(item => {
                        result.push({
                            title: item.label,
                            expand: item.expanded,
                            itemId: item.data.itemId,//这种组织结构可能要变，可能会全复制数据结构
                            children: this.filterChildrenData(item.children)
                        })
                    });
                }
                return result;
            },

            // 请求 获取本法变迁数据
            getLawCauseData() {
                reqLawDetailsCause({ id: this.$route.query.id, excuteTypeId: 0 }).then(res => {
                    // reqLawDetailsCause({id: 29513, excuteTypeId: 0}).then(res => {
                    if (res.ok) {
                        this.LawCauseData = res.data;
                        this.LawCauseData.forEach(item => {
                            if (item.children && item.children.length > 0) {
                                item.children.forEach(citem => {
                                    console.log(citem.excuteTypeName)
                                })

                            }
                        });
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .v-lawdetails {
        background-color: #f7f8f8;
    }

    .content {
        margin: 0 auto;
        width: 1200px;
        min-height: calc(100% - 50px - 112px);
        background-color: #f7f8f8;
    }

    .details-panel {
        overflow: hidden;
        margin-bottom: 20px;
        background-color: #fff;
    }

    .law-title {
        padding: 30px 0;
        border-bottom: 3px solid #cecfd3;
        font-size: 20px;
        font-weight: bold;
        color: #333;
        text-align: center;
    }

    .law-info {
        margin: 30px 34px 0;
        padding: 20px;
        background-color: #f7f7f7;
    }

    .info-p-container {
        width: 50%;
    }

    .law-info-p {
        margin: 8px 0;
        font-size: 14px;
    }

    .law-info-p span {
        display: inline-block;
    }

    .info-key {
        width: 120px;
        color: #999
    }

    .law-info-p .info-value {
        color: #1867DD;
    }

    .law-info-p .info-key-gray {
        color: #999;
    }

    .law-change,
    .law-cause {
        margin: 20px 34px;
        border: 1px solid #f7f7f7;
        background-color: #fff;
    }

    .panel-title {
        padding: 8px 30px;
        font-size: 16px;
        color: #515a6e;
        background-color: #f7f7f7;
    }

    .law-change .panel-content {
        padding: 10px 30px;
    }

    .timeline-list {
        list-style: none;
    }

    .timeline-item {
        position: relative;
        display: flex;
        align-items: center;
    }

    .timeline-time {
        width: 72px;
        font-size: 14px;
        color: #999;
    }

    .timeline-icon {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 12px;
        left: 92px;
        width: 19px;
        height: 18px;
        background-color: #fff;
    }

    .icon-timeline {
        width: 20px;
        height: 22px;
        background: url(../../assets/img/icon-timeline.png) 0 0 no-repeat;
    }

    .icon-item {
        border-radius: 10px;
        width: 12px;
        height: 12px;
        background-color: #10c157;
    }

    .timeline-line {
        margin: 0 30px 0 28px;
        width: 2px;
        height: 40px;
        background-color: #d8d8d8;
    }

    .timeline-describe {
        font-size: 14px;
        color: #333;
    }

    .timeline-label span {
        margin-left: 20px;
        padding: 2px 8px;
        border: 1px solid #6cb4d7;
        border-radius: 12px;
        font-size: 12px;
        color: #6cb4d7;
    }

    .law-cause .panel-content {
        padding: 10px 30px;
    }

    .cause-nav {
        border-right: 1px solid #dfdfdf;
    }

    .cause-details {
        padding: 10px 30px;
    }

    .cause-details-title {
        margin: 10px 0;
        font-size: 16px;
        font-weight: bolder;
        text-align: center;
        color: #333;
    }

    .cause-details-law {
        font-size: 16px;
    }

    .cause-details-law-active {
        padding: 10px 5px 5px 5px;
        background: rgba(33, 143, 196, 0.2);
    }

    .cause-details-children-active {
        padding: 10px 5px 5px 5px;
        background: rgba(33, 143, 196, 0.2);
    }

    .cause-details-span {
        padding: 10px;
        border-radius: 3px;
        width: 80%;
    }
    
    .cause-details-span-active {
        background: rgba(33, 143, 196, 0.3);
    }

    .law-ztk {
        margin-right: 6px;
        font-weight: bold;
        color: #333;
    }

    .law-text {
        color: #515a6e;
    }

    .cause-details-item {
        margin: 24px 0;
    }

    .cause-details-line1,
    .cause-details-line2 {
        display: flex;
        align-items: center;
    }

    .item-fix-width {
        display: inline-block;
        margin-right: -14px;
        width: 100px;
    }

    .item-font-weight {
        font-weight: bold;
    }

    .item-margin {
        margin: 0 8px 0 0;
        width: 90px;
    }

    .hide-panel {
        display: none;
    }

    .cause-details-panel {
        padding: 10px 20px;
        border: 1px solid #dfdfdf;
        border-radius: 3px;
        background: rgba(33, 143, 196, 0.08);
    }

    .details-panel-title {
        margin-right: 10px;
        font-weight: bold;
    }

    .panel-p-item {
        margin: 10px 0;
    }

    .cl-table {
        margin: 10px auto;
        border-left: 1px solid #afafaf;
        border-top: 1px solid #afafaf;
        width: 100%;
    }

    .cl-table td,
    .cl-table th {
        padding: 2px 4px;
        border-right: 1px solid #afafaf;
        border-bottom: 1px solid #afafaf;
        text-align: center;
    }

    .punish-table {
        margin: 10px auto;
        border-left: 1px solid #afafaf;
        border-top: 1px solid #afafaf;
        width: 100%;
    }

    .punish-table td,
    .punish-table th {
        padding: 2px 8px;
        border-right: 1px solid #afafaf;
        border-bottom: 1px solid #afafaf;
        text-align: center;
    }
</style>